import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './ConsultoriaPage.css';

const ConsultoriaPage = () => {
  return (
    <>
      <Header />
      
      <div className="consultoria-container">
        <div className="consultoria-content">
          <div className="consultoria-left">
            <div className="consultoria-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">CONSULTORIA EM REGULARIZAÇÕES E COMPLIANCE</h1>
            </div>
          </div>
          
          <div className="consultoria-right">
            
            <div className="consultoria-description">
              <p className="consultoria-intro">
                Transforme a conformidade da sua empresa em um processo ágil e confiável:
              </p>
              
              <ul className="consultoria-services">
                <li>Análise de conformidade documental e societária;</li>
                <li>Regularização de pendências junto a órgãos públicos;</li>
                <li>Adequação à LGPD;</li>
                <li>Implementação de políticas de compliance corporativo;</li>
                <li>Auditoria e organização de documentação empresarial;</li>
                <li>Orientação sobre boas práticas de governança.</li>
              </ul>
              
              <p>
                Soluções inteligentes da Veridicus acompanham cada etapa de adequação regulatória. A plataforma automatiza 
                verificações, organiza documentos e gera relatórios estratégicos, identificando inconsistências rapidamente.
              </p>
              
              <p>
                Pendências em órgãos públicos são tratadas de forma segura, garantindo conformidade contínua e permitindo que sua 
                equipe concentre esforços em decisões de crescimento e melhorias na governança corporativa.
              </p>
            </div>
            
            <div className="consultoria-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="consultoria-navigation">
          <Link to="/servicos/apoio-juridico" className="nav-prev">
            ← APOIO A ESCRITÓRIOS E DEPARTAMENTOS JURÍDICOS
          </Link>
          <Link to="/servicos/presenca-estrategica" className="nav-next">
            PRESENÇA ESTRATÉGIA EM ÓRGÃOS E CONSELHOS →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default ConsultoriaPage;